module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancelLabel":"Cancel","confirmLabel":"Select Vendor","searchPlaceholder":"Search text","title":"Search for Vendor","name":"Name","mail":"Mail","vendorNumber":"Vendor.Nr."},"no":{"cancelLabel":"Avbryt","confirmLabel":"Velg leverandør","searchPlaceholder":"Søketekst","title":"Søk etter leverandør","name":"Navn","mail":"Mail","vendorNumber":"Lev.nr."}}')
  delete Component.options._Ctor
}
